import React from "react";
import SubscriptionCard from "../../../components/Website/SubscriptionCard";

function Subscriptions() {
  const cardData = [
    {
      subscription: "Super Hot Deals",
      price: "500",
      deliveryCharges: "100",
      discount: "0",
      totalMealQuantity: 25,
      categories: ["Pizza"],
      expiry: "25",
      details: "This is for testing purpose",
    },
    {
      subscription: "Super Hot Deals",
      price: "500",
      deliveryCharges: "100",
      discount: "0",
      totalMealQuantity: 25,
      categories: ["Pizza"],
      expiry: "25",
      details: "This is for testing purpose",
    },
  ];
  return (
    <section className="bg-white">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
          <h2 className="mb-4 text-[2rem] tracking-tight font-semibold text-gray-900">
            Subscribe Now and Save
          </h2>
        </div>
        <div className="flex gap-8 flex-wrap">
          {cardData.map((data, index) => (
            <SubscriptionCard key={index} data={data} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Subscriptions;
